import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex, SvgIcon, Text } from 'Components/Base';
import { get } from 'Components/Base/constants';

const Status = {
  NOT_STARTED: 'รอทบทวน',
  IN_PROGRESS: 'กำลังทบทวน',
  END: 'เสร็จแล้ว',
};

const StatusColorMap = {
  NOT_STARTED: 'guidedPractice.statusWarningColor',
  IN_PROGRESS: 'primary',
  END: 'success',
};

const GuidedPracticeItemCard = styled(Flex)`
  background: white;
  padding: ${(props) => (props.isMobile ? '16px' : '20px 24px')};
  border-radius: 8px;
  flex-direction: ${(props) => (props.isTablet ? 'column' : 'row')};
  justify-content: space-between;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:focus {
    background-color: ${({ theme }) => theme.colors.bsGrays.gray200};
  }
`;

const Wrapper = styled(Flex)`
  grid-column-gap: 16px;
  & > *:not(:first-child) {
    border-left: ${get(`colors.greyscale.grey4`)} 2px solid;
    padding-left: 16px;
  }
`;

const TextItem = (props) => <Text textStyle={'body1'} {...props} />;

const GuidedPracticeCard = ({ item, onClick, isMobile, isTablet, ...restProps }) => {
  const statusText = Status[item.status] || Status.NOT_STARTED;
  const statusColor = StatusColorMap[item.status] || StatusColorMap.NOT_STARTED;

  return (
    <GuidedPracticeItemCard
      isMobile={isMobile}
      isTablet={isTablet}
      onClick={onClick}
      {...restProps}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        width={'100%'}
        flexGrow={1}
        gridColumnGap={2}
      >
        <Flex
          flexDirection={isTablet ? 'column' : 'row'}
          gridRowGap={isTablet ? 3 : 0}
          flexGrow={1}
          justifyContent="space-between"
          style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
        >
          <TextItem
            width={isTablet ? '100%' : 'auto'}
            minWidth={0}
            textAlign="start"
            fontWeight={700}
            style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {item.title}
          </TextItem>
          <Wrapper>
            <TextItem>{item.subject}</TextItem>
            <TextItem>{item.questionAmount} ข้อ</TextItem>
            <TextItem color={statusColor} textAlign={'right'}>
              {statusText}
            </TextItem>
          </Wrapper>
        </Flex>
        <SvgIcon icon={SvgIcon.ICON_LIST.NEXT} style={{ minWidth: 24, minHeight: 24 }} />
      </Flex>
    </GuidedPracticeItemCard>
  );
};

GuidedPracticeCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    status: PropTypes.oneOf(['NOT_STARTED', 'IN_PROGRESS', 'END']),
    questionAmount: PropTypes.number,
    subject: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
};

export default GuidedPracticeCard;
